import { type HistoryMessage, isChatMessage } from './type';

type PersistedMessageId = {
  id: string | null;
  role: 'user' | 'assistant';
};

export function syncMissingMessageIds(
  messages: HistoryMessage[],
  persistedMessages: PersistedMessageId[]
): HistoryMessage[] | null {
  const missingIndexes = messages
    .map((message, index) =>
      isChatMessage(message) && !message.id ? index : -1
    )
    .filter(index => index !== -1);
  if (!missingIndexes.length) return null;

  const nextMessages = messages.slice();
  let persistedIndex = persistedMessages.length - 1;
  for (let i = missingIndexes.length - 1; i >= 0; i--) {
    const messageIndex = missingIndexes[i];
    const message = nextMessages[messageIndex];
    if (!isChatMessage(message)) continue;

    while (
      persistedIndex >= 0 &&
      persistedMessages[persistedIndex].role !== message.role
    ) {
      persistedIndex--;
    }

    const persistedMessage = persistedMessages[persistedIndex];
    if (!persistedMessage?.id) continue;

    nextMessages[messageIndex] = {
      ...message,
      id: persistedMessage.id,
    };
    persistedIndex--;
  }

  return nextMessages;
}
